<ng-template #searchLocationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Search Location</h4>
    <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="handleClose(modal)"></button>
  </div>
  <div class="modal-body">
    <div class="search-location-block">
      <app-google-location-search #picker [isEdit]="false" [addressOnboarding]="addressOnboarding" [cityOnboarding]="cityOnboarding"
                                  [businessDetaillat]="businessDetaillat" [businessDetaillng]="businessDetaillng"></app-google-location-search>
      <app-button class="d-flex justify-content-center mt-3" [btnCss]="'btn btn-primary'" [btnTitle]="'Select on Map'" [btnText]="'Select on Map'"
                  [isDisable]="!picker.selectedLocation || !picker.mapsReady"
                  (onBtnClick)="confirmSelection(picker.selectedLocation, modal)"></app-button>
    </div>
  </div>
</ng-template>
<app-confirm-location #confirmLocationModal (confirmed)="confirmed($event)"></app-confirm-location>
